import script from "./show-time-ago.vue?vue&type=script&lang=ts&setup=true"
export * from "./show-time-ago.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__